import { createReducer } from '@reduxjs/toolkit'
import { MyNFTType } from 'hooks/setGetListMyNft'

import { setCurrentProfit, setListNFT, setMyNft } from './actions'
import { ICurrentProfit, NFTItemType } from './type'

export interface WalletState {
  myNft: MyNFTType[]
  listNFT: NFTItemType[]
  currentProfit?: ICurrentProfit
}

export const initialState: WalletState = {
  myNft: [],
  listNFT: [],
}

export default createReducer(initialState, (builder) =>
  builder
    .addCase(setMyNft, (state, action) => {
      state.myNft = action.payload
    })
    .addCase(setListNFT, (state, action) => {
      return {
        ...state,
        listNFT: action?.payload,
      }
    })
    .addCase(setCurrentProfit, (state, action) => {
      return {
        ...state,
        currentProfit: { ...action?.payload },
      }
    }),
)
